import type { FormLayoutCells, FormLayoutRow } from '@/types';
import { useEffect, useState } from 'react';
import DialogArticle from '@/components/dialog-article';
import Checkbox from '@/components/checkbox';
import { useAppDispatch, useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import { DialogSlice } from '@/redux/dialog';
import { UserFormSlice } from '@/redux/user-form';
import Converter from '@/utils/converter';
import Track from '@/utils/track';

export default function AdditionalTermsDialog() {
  const agb = useAppSelector(UserFormSlice.selectors.agb);
  const { schema, layout } = useAppSelector(ConfigSlice.selectors.signForm);
  const dispatch = useAppDispatch();
  const [visibleKeys, setVisibleKeys] = useState<string[]>([]);

  const removeHiddenRow = (row: FormLayoutRow): boolean => !row.hidden?.call(null);

  const removeHiddenCell = (row: FormLayoutCells): boolean => !row.hidden?.call(null);

  const onAdditionalTermsChange = (value: boolean, key: string) => {
    dispatch(
      UserFormSlice.actions.setUserFormKey({
        schema: schema(visibleKeys),
        layout,
        data: { key, value: Converter.Boolean.ToBooleanString(value) },
      }),
    );
    if (value) {
      dispatch(DialogSlice.actions.closeDialog());
      Track.DataLayer.AdditionalTermsAccepted();
    }
  };

  useEffect(() => {
    setVisibleKeys(
      layout
        .filter(removeHiddenRow)
        .map((row) => row.cells)
        .reduce((cells, row) => [...cells, ...row], [])
        .filter(removeHiddenCell)
        .map((cell) => cell.key),
    );
  }, [layout]);

  return (
    <DialogArticle>
      <h1 className='h1'>Einwilligung zur Datenweiterleitung</h1>
      <p className='p'>
        Um Ihnen als Besucher maximale Beratungsqualität zu gewährleisten, leiten wir Verkehrsrechtsanfragen zum Zweck
        einer kostenlosen Erstberatung an die erfahrenen Anwälte von SOS Verkehrsrecht weiter:
      </p>
      <p className='p'>
        <b className='b'>SOS Verkehrsrecht</b>
        <br />
        rightmart Berlin Rechtsanwaltsgesellschaft mbH
        <br />
        Greifswalder Straße 207
        <br />
        10405 Berlin
        <br />
        E-Mail kanzlei@sos-verkehrsrecht.de
        <br />
        Vollständiges Impressum unter:{' '}
        <a className='a' href='https://sos-verkehrsrecht.de/bussgeldcheck/#impressum'>
          https://sos-verkehrsrecht.de/
        </a>
      </p>
      <div className='center'>
        <Checkbox
          value={Converter.BooleanString.ToBoolean(agb)}
          label='Ich bin mit der Datenweiterleitung einverstanden.'
          name='agb'
          className='modal-checkbox'
          onChange={onAdditionalTermsChange}
        />
      </div>
    </DialogArticle>
  );
}
